import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getSettingList = (payload, callback) =>
  req.list(
    c.GET_SETTING,
    'api/v1/administrators/real_property_taxes/settings/property_index_number',
    payload,
    callback
  );

export const getSingleSetting = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_SETTING,
    'api/v1/administrators/real_property_taxes/settings/property_index_number',
    payload,
    callback
  );

export const updatePin = (id, payload, callback) =>
  req.update(
    c.UPDATE_PIN,
    `api/v1/administrators/real_property_taxes/settings/property_index_number/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );
